export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4706.4daf11c2.jpg";